const CardTotalLicenciados = (props) => {
    return(
        <article className="card">
          <div className="card-header">
            <div className="card-title">
              <span>👥</span>
              <span>Total de licenciados</span>
            </div>
          </div>
          <div className="card-body">
            <div className="card-value" id="totalLicenciados">{props.total}</div>
            <div className="card-sub">
              Contagem geral de usuários licenciados cadastrados no sistema.
            </div>
          </div>
        </article>
    )
}

export default CardTotalLicenciados;